/* Halune — small, dependency-free enhancements. Every feature degrades to plain HTML forms and links. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* Header: transparent only while it sits over a full-height hero at the top of the page. */
  function initHeader() {
    var header = $('[data-hl-header]');
    if (!header) return;
    var main = document.getElementById('MainContent');
    var first = main && main.querySelector('.shopify-section');
    var hero = first && first.querySelector('[data-hl-hero="full"], [data-hl-hero="large"]');
    if (!hero) return;
    var menu = $('[data-hl-menu]');
    function update() {
      var over = window.scrollY < Math.max(40, hero.offsetHeight - header.offsetHeight - 20);
      header.classList.toggle('is-overlay', over && !(menu && menu.open));
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (menu) menu.addEventListener('toggle', update);
  }

  /* Mobile menu: lock scroll while open, close with Escape or on link click. */
  function initMenu() {
    var menu = $('[data-hl-menu]');
    if (!menu) return;
    var header = $('[data-hl-header]');
    menu.addEventListener('toggle', function () {
      document.documentElement.classList.toggle('hl-lock', menu.open);
      if (header) header.classList.toggle('is-menu', menu.open);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); }
    });
    $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { menu.open = false; }); });
  }

  /* Reveal on scroll. */
  function initReveal() {
    var els = $$('[data-hl-reveal]');
    if (reduced || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Product gallery thumbnails. */
  function initGallery() {
    var g = $('[data-hl-gallery]');
    if (!g) return;
    var track = $('[data-hl-track]', g);
    var thumbs = $$('[data-hl-thumb]', g);
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = +b.getAttribute('data-hl-thumb');
        track.scrollTo({ left: track.clientWidth * i, behavior: reduced ? 'auto' : 'smooth' });
      });
    });
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }, 60);
    }, { passive: true });
  }

  /* Kit configurator. Radios carry real variant ids; this only syncs the logo variant and the summary. */
  function initConfigurator() {
    var form = $('[data-hl-config]');
    var dataEl = $('[data-hl-kits]');
    if (!form || !dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var radios = $$('input[name="id"]', form);
    var logo = $('[data-hl-logo]', form);
    var logoSwitch = $('[data-hl-logo-switch]', form);
    var logoNote = $('[data-hl-logo-note]', form);
    var quote = $('[data-hl-quote]', form);

    function set(field, value) { $$('[data-hl-f="' + field + '"]').forEach(function (el) { el.textContent = value; }); }

    function update(pushUrl) {
      var r = radios.filter(function (x) { return x.checked; })[0];
      if (!r) return;
      var lamps = r.getAttribute('data-hl-lamps');
      var k = data.kits[lamps];
      if (!k) return;
      var eligible = !!k.logoId && +lamps >= data.logoMin;
      if (logoSwitch) logoSwitch.hidden = !eligible;
      if (logoNote) logoNote.hidden = eligible;
      var withLogo = eligible && logo && logo.checked;
      radios.forEach(function (x) {
        var kk = data.kits[x.getAttribute('data-hl-lamps')];
        if (kk) x.value = (x === r && withLogo) ? kk.logoId : kk.id;
      });
      set('kit', lamps + ' lamps');
      set('stations', k.stations);
      set('trial', k.trial);
      set('logo', withLogo ? k.logoExtra : (eligible ? 'Not selected' : 'From ' + data.logoMin + ' lamps'));
      set('prep', withLogo && k.logoPrep ? k.logoPrep : k.prep);
      set('transit', k.transit);
      set('credit', k.credit);
      set('price', withLogo ? k.logoPrice : k.price);
      if (quote) quote.href = quote.href.split('?')[0] + '?kit=' + lamps + (withLogo ? '&logo=1' : '');
      if (pushUrl && window.history && history.replaceState) {
        var u = new URL(location.href);
        u.searchParams.set('variant', r.value);
        history.replaceState(null, '', u.toString());
      }
    }
    radios.forEach(function (r) { r.addEventListener('change', function () { update(true); }); });
    if (logo) logo.addEventListener('change', function () { update(true); });
    update(false);

    /* Sticky mobile bar: shown whenever the main button is off screen (above or below). */
    var bar = $('[data-hl-sticky]');
    var add = $('[data-hl-add]', form);
    if (bar && add && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting;
        bar.classList.toggle('is-on', show);
        document.body.classList.toggle('hl-has-sticky', show);
      }).observe(add);
    }
  }

  /* Table sizer. */
  function initSizer() {
    var box = $('[data-hl-sizer]');
    var dataEl = $('[data-hl-sizer-data]');
    if (!box || !dataEl) return;
    var kits;
    try { kits = JSON.parse(dataEl.textContent).sort(function (a, b) { return a.lamps - b.lamps; }); } catch (e) { return; }
    if (!kits.length) return;
    var input = $('[data-hl-tables]', box);
    var outKit = $('[data-hl-out-kit]', box), outDetail = $('[data-hl-out-detail]', box), outLink = $('[data-hl-out-link]', box);
    var product = box.getAttribute('data-product'), quoteUrl = box.getAttribute('data-quote');
    function render() {
      var n = Math.max(1, Math.min(999, parseInt(input.value, 10) || 1));
      var kit = kits.filter(function (k) { return k.lamps >= n; })[0];
      if (kit) {
        var spare = kit.lamps - n;
        outKit.textContent = 'Kit ' + kit.lamps;
        outDetail.textContent = kit.price + ' · ' + kit.per + ' per lamp, stations included' + (spare ? ' · ' + spare + ' spare ' + (spare === 1 ? 'lamp' : 'lamps') : '');
        outLink.textContent = 'See Kit ' + kit.lamps;
        outLink.href = product + '?variant=' + kit.id;
      } else {
        outKit.textContent = 'Custom quote';
        outDetail.textContent = 'More than ' + kits[kits.length - 1].lamps + ' tables: we prepare a written quote for your fleet.';
        outLink.textContent = 'Request a quote';
        outLink.href = (quoteUrl || '#') + '?tables=' + n;
      }
    }
    $$('[data-hl-step]', box).forEach(function (b) {
      b.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 0) + (+b.getAttribute('data-hl-step')));
        render();
      });
    });
    input.addEventListener('input', render);
    render();
  }

  /* Quote form: pre-fill from ?kit= / ?tables=, add a reference, show it after sending. */
  function initQuote() {
    var form = $('[data-hl-quote-form]');
    if (!form) return;
    var q = new URLSearchParams(location.search);
    var sel = $('[data-hl-kit-select]', form);
    var kit = q.get('kit'), tables = q.get('tables');
    if (sel && kit) {
      var v = q.get('logo') ? 'Logo on lamps' : 'Kit ' + kit;
      $$('option', sel).forEach(function (o) { if (o.value === v) sel.value = v; });
    }
    var t = $('#hlq-tables', form);
    if (t && (tables || kit) && !t.value) t.value = tables || kit;
    var ref = $('[data-hl-ref]', form);
    var sent = $('[data-hl-sent]', form);
    var store = window.sessionStorage;
    if (sent) {
      var out = $('[data-hl-ref-out]', sent);
      try { var r = store && store.getItem('hl_ref'); if (r && out) out.textContent = 'Your reference: ' + r + '.'; } catch (e) {}
      sent.focus();
      return;
    }
    form.addEventListener('submit', function () {
      var d = new Date();
      var r = 'HL-' + String(d.getFullYear()).slice(2) + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2) + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();
      if (ref) ref.value = r;
      try { store && store.setItem('hl_ref', r); } catch (e) {}
    });
  }

  function start() { initHeader(); initMenu(); initReveal(); initGallery(); initConfigurator(); initSizer(); initQuote(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
